import useSWR from 'swr'
import fetcher from '../utils/fetcher'

const useDealers = (country, city) => {
    const url = `https://extranet.greentec.eu/api/dealers?filter[country_code]=${country}&filter[city]=${city}`
    const {data, error} = useSWR(url, fetcher)

    return {
        dealers: data,
        dealersLoading: !error && !data,
        dealersError: error
    }
}

export default useDealers